// extracted by mini-css-extract-plugin
export default {"Thumbnail":"VideoThumbnail_Thumbnail__EP7u8"};